
import { QuiltySubscriptionPlanType } from "@gsx/common";
import { SubscriptionPlanType } from "@gsx/common/src/types/models/subscription";
import { Container } from "inversify";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import SubscriptionUpgradeButton from "./SubscriptionUpgradeButton.vue";

@Component({
    components: {
        SubscriptionUpgradeButton,
    },
})
export default class SubscriptionUpgrade extends Vue {
    @Inject("container") container!: Container;
    @Prop({ default: false }) locked!: boolean;
    @Prop({ default: "global" }) subscriptionType!: "quilty" | "global";
    @Prop({ default: SubscriptionPlanType.Individual }) subscriptionNeeded!:
        | SubscriptionPlanType
        | QuiltySubscriptionPlanType;

    get upgradeMessage() {
        if (this.subscriptionType === "quilty") {
            return `We partner with Quilty Analytics to provide you additional analytics. Please upgade to see our premium pricing and unlock this section along with more amazing features.`;
        }

        return `Sorry, this is a Global Space Exchange premium feature. Please upgrade to a Global Space Exchange Enterprise Subscription to see our premium pricing and unlock this section along with more amazing features.`;
    }

    get imagePath() {
        if (this.subscriptionType === "quilty") {
            return "quilty_black_blue_transparent.svg";
        }

        return "logo.svg";
    }
}
